import React, { Component } from 'react';
import PropTypes from 'prop-types';
import * as actions from '../../actions';
import { SingleInput } from '@imprivata/nucleus';
import headerImage from '../../images/pin.svg';
import { connect } from 'react-redux';
import LogoutStyled from '../shared/LogoutStyled';
import MoreOptions from '../shared/MoreOptions';

/**
 * PinPage Component
 */
export class PinPage extends Component {
  /**
   * The allowed properties for the PinPage component
   * @param {function} verifyPin verify pin token code
   * @param {bool} isLoading is something on the page loading?
   * @param {array} errorCode the error codes to be displayed
   * @param {array} availableModalities available modalities to switch to
   */

  static propTypes = {
    verifyPin: PropTypes.func.isRequired,
    errorCode: PropTypes.array,
    isLoading: PropTypes.bool,
    availableModalities: PropTypes.arrayOf(PropTypes.string),
    /** Use Parkland custom UX */
    useCustomUX: PropTypes.bool,
    isClinicalWorkflow: PropTypes.bool,
  };

  static defaultProps = {
    availableModalities: [],
    authenticatedModalities: [],
    useCustomUX: false,
  };

  submit = state => {
    // what is state here ?
    // guess is that from connect but what is it ?
    this.props.verifyPin(state.tokenCode);
  };

  render() {
    const {
      isLoading,
      availableModalities,
      useCustomUX,
      username,
      allowEditUsername,
    } = this.props;

    const modalities = (availableModalities) ? availableModalities.filter(e => e !== 'pin' && e !== 'tempcode') : [];
    const moreOptions = (modalities.length > 0) ? <MoreOptions currentModality='pin' /> : null;
    const logoutStyle = useCustomUX ? 'black' : 'white';

    return (
      <div className='content-body'>
        <SingleInput
          isLoading={isLoading}
          headerImage={headerImage}
          headerTitle='Enter Imprivata PIN'
          placeholderText='Imprivata PIN'
          submitText='Confirm your identity'
          onSubmit={this.submit}
          retryText=''
          inputMask={false}
          autoFocus={true}
          moreOptionsLink={moreOptions}
          logoutComponent={<LogoutStyled type={logoutStyle} />}
          useCustomUX={useCustomUX}
          username={username}
          allowEditUsername={allowEditUsername}
          resetUsername={this.props.reset}
        />
      </div>
    );
  }
};

const mapStateToProps = state => {
  const {
    errorCode, availableModalities, serverState, useCustomUX,
    username, isClinicalWorkflow, allowEditUsername,
  } = state.login;
  return {
    errorCode,
    availableModalities,
    serverState,
    useCustomUX,
    username,
    allowEditUsername,
    isClinicalWorkflow,
  };
};

const mapDispatchToProps = dispatch => {
  return {
    verifyPin: tokenCode => {
      dispatch(actions.verifyPin(tokenCode) );
    },
    reset: () => {
      dispatch(actions.reset() );
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(PinPage);
